import { useState } from 'react';
import { Avatar, Badge, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { LogoutOutlined, LoginOutlined } from '@mui/icons-material';
import useStore from '../../store';
import { useAuth } from '../../Auth/AuthManager';
import { stringAvatar } from '../../Utils/avatarUtils';

const AccountMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const username = useStore((state) => state.username);
    const isConnected = useStore((state) => state.connected);
    const { isAuthenticated, logout, showLoginDialog } = useAuth();

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title={`Hello ${username}`}>
                <Badge color={isConnected ? 'success' : 'error'} variant="dot">
                    <IconButton
                        onClick={handleOpen}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={anchorEl ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={anchorEl ? 'true' : undefined}
                    >
                        <Avatar {...stringAvatar(username)} />
                    </IconButton>
                </Badge>
            </Tooltip>
            <Menu
                id="menu-account-appbar"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {isAuthenticated ? (
                    <MenuItem onClick={logout}>
                        <ListItemIcon>
                            <LogoutOutlined fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Logout</ListItemText>
                    </MenuItem>
                ) : (
                    <MenuItem onClick={showLoginDialog}>
                        <ListItemIcon>
                            <LoginOutlined fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Login</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export default AccountMenu;
